import { render } from "./music.vue?vue&type=template&id=1ec1ea66&scoped=true"
import script from "./music.vue?vue&type=script&lang=js"
export * from "./music.vue?vue&type=script&lang=js"

import "./music.vue?vue&type=style&index=0&id=1ec1ea66&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1ec1ea66"

export default script